/**
 * Web client bundle entry · the canonical `/client` import on web.
 *
 * `@morfi/backend-sdk-v2/client` is a PLATFORM-CONDITIONAL export: this
 * file backs the `default` (web) condition; `src/platform/react-native/
 * client.ts` backs the `react-native` condition. A consumer that writes
 *
 *     import { useSdkTurnkey } from '@morfi/backend-sdk-v2/client';
 *
 * resolves to the web `useSdkTurnkey` here on web, and to the RN
 * `useSdkTurnkey` on React Native — without changing a line of app code.
 *
 * This file re-exports BOTH:
 *   1. the shared, platform-agnostic surface (`../../client.js` → codegen
 *      barrel + advanced composition primitives), and
 *   2. the web-only platform surface (`./index.js` → Turnkey vendor
 *      binding, OAuth popup/redirect connect hooks, the web tx-engine
 *      signing/submission hooks, the impersonation subsystem, the web
 *      adapter factories).
 *
 * `'use client'` is load-bearing and propagates to every re-exported
 * member at bundling time.
 *
 * The platform-agnostic rule is intact: this file lives UNDER
 * `src/platform/web/`, so importing web-only code here is legal. Core
 * code never imports it.
 */

'use client';

// 3 · Conflict resolution. `SdkAuthState` is a name used by BOTH the
//     platform-neutral auth store (`src/auth/state/auth-state.ts`, via
//     step 1) and the web auth-provider context (`src/platform/web/auth/
//     session/auth-provider.tsx`, via step 2) — they are distinct
//     interfaces. The platform-neutral store state is the canonical
//     cross-platform name, so re-export it EXPLICITLY here so it wins
//     the ambiguous star-export. The web auth-provider's state shape
//     stays reachable as the public `SdkAuthContextValue` (which
//     structurally extends it) — nothing is silently dropped.
export type { SdkAuthState } from '../../auth/state/auth-state.js';
// 1 · Shared platform-agnostic surface (codegen barrel + primitives).
export * from '../../client.js';
// 2 · Web-only platform surface (Turnkey, OAuth, tx-engine, impersonation,
//     web adapter factories, web persister helpers).
export * from './index.js';
